import React from 'react'
import Slider from "react-slick";



import { ProductCardStock } from '../admin/panelComponents/productsPanel/ProductCardStock'

export const Carrousel = ({productos,title}) => {

   

    const settings ={
        centerMode: true,
        centerPadding: '530px',
        slidesToShow:1,
        prevArrow:<p className='pe'></p>,
        nextArrow:<p className='pe'></p>,
        responsive: [
          {
            breakpoint: 1400,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '465px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 1200,
            settings: {
              arrows: true,
              centerMode: true,
              centerPadding: '375px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 990,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '250px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 769,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '120px',
              slidesToShow: 1
            }
          },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '55px',
                slidesToShow: 1
              }
            },

 
          ]
    }

  return (
    <div >


        <div className='container'>

            <div className='_productCardStock _carrousel '>
            <div className='title'>
        {title}

        </div>
    
        <Slider {...settings}>
                {productos.map(prod =>        
                            
                        <ProductCardStock  key={prod.id} item={prod}/>

                )}
        </Slider >
                </div>
        </div>


  </div>
  )
}
